<template>
    <div>

        <b-card>
            <b-card-body>
                <h4 class="mb-4">New Session</h4>

                <b-form-row>
                    <b-col cols="6">
                        <label>Session Title <span class="required">*</span></label>
                        <b-form-input v-model="newSession.title"></b-form-input>
                    </b-col>
                    <b-col>
                        <label>Session/Slot <span class="required">*</span></label>
                        <b-form-input v-model="newSession.slot" placeholder="ie. Keynote, Breakout 1"></b-form-input>
                    </b-col>
                    <b-col>
                        <label>Presenter(s) <span class="required">*</span></label>
                        <b-form-input v-model="newSession.presenter"></b-form-input>
                    </b-col>
                </b-form-row>

                <b-form-row class="mt-2">
                    <b-col cols="8">
                        <label>Online Presentation/Meeting Link (if applicable)</label>
                        <b-form-input v-model="newSession.online_mtg_link"></b-form-input>
                    </b-col>
                    <b-col>
                        <label>Access Button Label</label>
                        <b-form-input v-model="newSession.online_mtg_button"></b-form-input>
                    </b-col>
                </b-form-row>

                <b-form-row class="mt-2">
                    <b-col>
                        <b-form-group>
                            <label>Start Date <span class="required">*</span></label>
                            <b-form-datepicker id="datepicker-placeholder" local="en" v-model="newSession.start_at"></b-form-datepicker>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group>
                            <label>Start Time <span class="required">*</span></label>
                            <b-form-timepicker v-model="newSession.start_time" locale="en"></b-form-timepicker>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group>
                            <label>End Date <span class="required">*</span></label>
                            <b-form-datepicker id="datepicker-placeholder2" local="en" v-model="newSession.end_at"></b-form-datepicker>
                        </b-form-group>
                    </b-col>

                    <b-col>
                        <b-form-group>
                            <label>End Time <span class="required">*</span></label>
                            <b-form-timepicker v-model="newSession.end_time" locale="en"></b-form-timepicker>
                        </b-form-group>
                    </b-col>
                </b-form-row>

                <b-form-row class="mt-3">
                    <b-col>
                        <label>Description <span class="required">*</span></label>

                        <quill-editor v-model="newSession.description" ref="myQuillEditor" :options="editorOption">
                        </quill-editor>
                    </b-col>
                </b-form-row>
                <b-form-row class="mt-3">
                    <b-col>
                        <label>Information <span class="required">*</span></label>

                        <quill-editor v-model="newSession.information" ref="myQuillEditor" :options="editorOption">
                        </quill-editor>
                    </b-col>
                </b-form-row>
                <b-row>
                    <b-col>
                        <b-button variant="success" class="mt-5" @click="submit()" :disabled="!newSession.title || !newSession.slot || !newSession.presenter || !newSession.start_at || !newSession.start_time"><i class="far fa-check mr-3"></i>New Session</b-button>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </div>

</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import {apiUrl} from '@/constants/config';

    export default {
        name: "sess-new",
        components: {},
        props: ['id'],
        data: function () {
            return {
                newSession: {
                    online_mtg_link: '',
                    online_mtg_button: '',
                    description: '',
                    information: ''
                },
                editorOption: {
                    // some quill options
                },
                content: '',
                apiUrl: apiUrl,
            }
        },
        methods: {
            ...mapActions(['submitSession']),

            submit() {
                let startAt = new Date(this.newSession.start_at + ' ' + this.newSession.start_time)
                let endAt = new Date(this.newSession.end_at + ' ' + this.newSession.end_time)

                let payload = {
                    conference_id: this.id,
                    title: this.newSession.title,
                    slot: this.newSession.slot,
                    presenter: this.newSession.presenter,
                    start_at: startAt.toISOString(),
                    end_at: endAt.toISOString(),
                    description: this.newSession.description,
                    information: this.newSession.information,
                    online_mtg_link: this.newSession.online_mtg_link,
                    online_mtg_button: this.newSession.online_mtg_button
                }

                this.submitSession(payload).then(() => {
                    this.$notify('success', 'Session Created', 'Session has been saved.', {duration: 5000, permanent: false});
                    this.$router.push('/org/conference/' + this.id + '/sessions');
                });
            },

        },
        computed: {
            ...mapGetters(['token'])
        },
        mounted: function () {

        }
    }
</script>

<style lang="scss" scoped>
    @import '~@/assets/scss/_variables.scss';

</style>
